import { render, staticRenderFns } from "./tableModelPart.vue?vue&type=template&id=a59a65f4"
import script from "./tableModelPart.vue?vue&type=script&lang=js"
export * from "./tableModelPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports